import type { ArticleImageProps } from '@/app/components/ArticleCardsModule';
import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';

interface StressBlogCardProps {
  articleCards: ArticleCardDataProps[];
  articleImage: ArticleImageProps;
}

const stressBlog = (localePartialUrl: string): StressBlogCardProps => ({
  articleCards: [
    {
      heading: 'stress_pulse_blog_1',
      buttonProps: {
        ariaLabel: 'press_read_article',
        external: true,
        color: 'purple-600',
        href: `https://ouraring.com/blog${localePartialUrl}oura-headspace-partnership/`,
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    },
    {
      heading: 'stress_pulse_blog_2',
      buttonProps: {
        ariaLabel: 'press_read_article',
        external: true,
        color: 'purple-600',
        href: `https://ouraring.com/blog${localePartialUrl}member-tips-strategies-to-lower-stress/`,
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    },
    {
      heading: 'stress_pulse_blog_3',
      buttonProps: {
        ariaLabel: 'press_read_article',
        external: true,
        color: 'purple-600',
        href: `https://ouraring.com/blog${localePartialUrl}building-resilience-recover-from-stress/`,
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    },
  ],
  articleImage: {
    alt: 'stress_press_blog_alt',
    buttonProps: {
      className: 'text-sandstone-500',
      external: true,
      href: `https://ouraring.com/blog${localePartialUrl}daytime-stress-feature/`,
      label: 'read_more',
      rel: 'noopener noreferrer',
      target: '_blank',
      variant: 'secondary-light',
    },
    heading: 'stress_pulse_blog_hero',
    src: 'stress/blog_hero',
    headingClassname: 'max-w-80',
  },
});

export default stressBlog;
